// extracted by mini-css-extract-plugin
export default {"chatWrap":"ChatLayout_chatWrap__9fCOW","chat":"ChatLayout_chat__w1E8I"};